const authDataKey = 'pasaroa-auth-data';
const accountListDataKey = 'pasaroa-account-list'

const siteConfigDataKey = 'site-config-data'

function setSiteConfigData(data) {
	localStorage.setItem(siteConfigDataKey, JSON.stringify(data));
}

function getSiteConfigData() {
	const authData = localStorage.getItem(siteConfigDataKey);

	if (authData) {
		const data = JSON.parse(authData);
		return data;
	}

	return null;
}


function loggedIn() {
	const authData = localStorage.getItem(authDataKey);

	if (authData) {
		const data = JSON.parse(authData);

		return data.token !== null;
	}

	return false;
}



function setData(data) {
	localStorage.setItem(authDataKey, JSON.stringify(data));
}

function setReferal(data) {
	localStorage.setItem('referal-key', JSON.stringify(data));
}

function getReferal() {
	const referal = localStorage.getItem('referal-key');

	if (referal) {
		return referal;
	}

	return null;
}

function setProfileData(data) {
	let token = getToken()

	setData({
		token: token,
		user: data
	})
}

function setImageData(data) {
	let token = getToken()
	let user = getUserData()

	user.user_image = data

	setData({
		token: token,
		user: user
	})
}

function getUserData() {
	const authData = localStorage.getItem(authDataKey);

	if (authData) {
		const data = JSON.parse(authData);

		return data.user;
	}

	return null;
}

function getToken() {
	const authData = localStorage.getItem(authDataKey);

	if (authData) {
		const data = JSON.parse(authData);

		return data.token;
	}

	return null;
}

function getRandomNumber() {
	const randomNumber = (min, max) => {
		return (Math.floor(Math.random() * (max - min + 1) + min));
	}
	const random = localStorage.getItem('randomNumber');

	if (!random) {
		localStorage.setItem('randomNumber', randomNumber(100, 499))
	}
	return localStorage.getItem('randomNumber')
}

function clearRandomNumber() {
	localStorage.removeItem('randomNumber');
}

function setListAccount(data) {
	localStorage.setItem(accountListDataKey, JSON.stringify(data));
}

function getListAccount() {
	const authData = localStorage.getItem(accountListDataKey);

	if (authData) {
		const data = JSON.parse(authData);

		return data;
	}

	return null;
}

function clearData() {
	localStorage.removeItem(authDataKey);
	localStorage.removeItem(accountListDataKey);
}

export default {
	loggedIn,
	setData,
	setReferal,
	getReferal,
	setProfileData,
	setImageData,
	getUserData,
	getToken,
	getRandomNumber,
	clearRandomNumber,
	setListAccount,
	getListAccount,
	clearData,
	setSiteConfigData,
	getSiteConfigData,

};